module.exports = __webpack_public_path__ + "assets/img/live.785ee711.png";